export interface SelectedTab {
  type: TabTypes;
}

export enum TabTypes {
  UPCOMING = 'UPCOMING',
  HISTORY = 'HISTORY',
}
